document.addEventListener('DOMContentLoaded', function () {
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const gallery = document.querySelector('[id^="MediaGallery-"]');
  if (!gallery) {
    return;
  }

  const slider = gallery.querySelector('.slider');
  if (!slider) {
    return;
  }
  
  let lastProcessedSlideId = null;

  const processSlide = (slide) => {
    if (!slide || slide.id === lastProcessedSlideId) {
      return;
    }
    lastProcessedSlideId = slide.id;
    
    gallery.querySelectorAll('video').forEach(video => {
        if (!video.paused) video.pause();
    });

    const deferredMedia = slide.querySelector('deferred-media');
    if (!deferredMedia) {
      return;
    }
    
    deferredMedia.loadContent();

    setTimeout(() => {
      const video = deferredMedia.querySelector('video');
      if (video) {
        video.play().catch(e => {});
      }
    }, 150);
  };

  const findAndProcessActiveSlide = () => {
    const sliderRect = slider.getBoundingClientRect();
    let bestVisibleSlide = null;
    let maxVisibility = 0;

    slider.querySelectorAll('.slider__slide').forEach(slide => {
      const slideRect = slide.getBoundingClientRect();
      const intersectionLeft = Math.max(sliderRect.left, slideRect.left);
      const intersectionRight = Math.min(sliderRect.right, slideRect.right);
      const intersectionWidth = intersectionRight - intersectionLeft;

      if (intersectionWidth > maxVisibility) {
        maxVisibility = intersectionWidth;
        bestVisibleSlide = slide;
      }
    });

    if (bestVisibleSlide) {
      processSlide(bestVisibleSlide);
    }
  };

  slider.addEventListener('scroll', debounce(findAndProcessActiveSlide, 200));

  setTimeout(() => {
      findAndProcessActiveSlide();
  }, 500);
});
